React = require 'react'
Auth = require 'db/auth'
_ = require 'underscore'
Util = require 'lib/util'
t = require('views/internal/recup-with-helpers')('home')

# taken from board-list-sidebar-item-view
module.exports = class HomeBoardSection extends React.Component
  displayName: 'HomeBoardSection'

  constructor: ->
    @onStarClick = @onStarClick.bind(@)

  onStarClick: (e) ->
    Util.preventDefault(e)

    boardId = @props.board.id
    boardStarList = Auth.me().boardStarList

    if !boardStarList.getBoardStar(boardId)?
      boardStarList.starBoard(boardId)
      # TODO: Track
    else
      boardStarList.unstarBoard(boardId)
      # TODO: Track

  render: t.renderable ->
    { board, showOrgName } = @props

    isLoggedIn = Auth.isLoggedIn()
    name = board?.get('name')
    orgName = board.getOrganization()?.get('displayName')
    url = board?.get('url')
    isStarred = board?.isStarred()

    backgroundBrightness = board.getPref('backgroundBrightness')
    backgroundTile = !!board.getPref('backgroundTile')
    backgroundImage = board.getPref('backgroundImage')
    backgroundImageThumbnail = if backgroundTile then backgroundImage else Util.smallestPreviewBiggerThan(board.getPref('backgroundImageScaled'), 400, 200)?.url ? backgroundImage
    backgroundColor = board.getPref('backgroundColor')

    t.div '.home-board-section-item', =>
      styles = {}
      if backgroundImageThumbnail
        styles['backgroundImage'] = t.urlify(backgroundImageThumbnail)
      if backgroundColor
        styles['backgroundColor'] = backgroundColor

      classes =
        'home-board-tile-link': true

      if backgroundBrightness
        classes[backgroundBrightness] = true

      t.span { class: t.classify(classes) }, =>
        t.a '.home-board-tile-info', { href: url }, ->
          t.span '.home-board-tile-link-thumbnail', style: styles

          t.span { class: t.classify('home-board-tile-link-text': true, details: true, 'has-sub-name': orgName) }, ->

            if showOrgName && orgName
              t.span '.home-board-tile-link-text-sub-name', { title: orgName }, ->
                t.text orgName
            t.span '.home-board-tile-link-text-name', { title: name }, ->
              t.text name

        if isLoggedIn
          t.a '.home-board-tile-links', { onClick: @onStarClick }, ->
            t.icon 'star', {
              class: t.classify('home-board-tile-star': true, 'starred': isStarred)
              title: t.l('star-board')
            }



// WEBPACK FOOTER //
// ./app/scripts/views/home/home-board-section-board.coffee